<template>
  <v-card
    tile
    light
  >
    <h-top-bar
      v-model="searching"
      :title="title"
      @search="search"
    />
    <h-groups
      v-show="! searching"
      @change="loadItems()"
    />
    <h-categories
      v-show="! searching"
      @change="loadItems()"
    />
    <v-card-text
      ref="catalogItems"
      class="pa-0"
    >
      <h-items
        :items="items"
        :show="showItems"
        :disabled="locked"
        :searching="searching"
        @scroll="scroll"
      />
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import HTopBar from './Toolbar/TopBar'
  import HGroups from './Toolbar/Groups'
  import HCategories from './Toolbar/Categories'
  import HItems from './Items'

  export default {
    components: {
      HTopBar,
      HGroups,
      HCategories,
      HItems,
    },

    data: () => ({
      title: '',
      items: [],
      showItems: false,
      searching: false,
    }),

    computed: {
      ...mapState('orders/dialogs', [
        'locked',
      ]),
      ...mapState('catalog', [
        'groupTab',
        'categoryTabs',
      ]),
      ...mapGetters('catalog', [
        'category',
        'categoryItems',
        'searchItems',
      ]),
    },

    watch: {
      searching (v) {
        v ? this.search() : this.loadItems()
      },
    },

    methods: {
      search () {
        this.items = this.searchItems
      },
      loadItems () {
        const categoryId = this.categoryTabs[this.groupTab]
        if (! categoryId) {
          return
        }
        this.showItems = false
        this.title = this.category(categoryId)?.name ?? ''
        this.items = this.categoryItems(categoryId)
        setTimeout(() => {
          this.showItems = true
          this.$refs.catalogItems.scrollTo(0, 0)
        }, 75);
      },
      scroll (n) {
        if (this.locked) {
          return
        }
        const height = 56 + 1 // list-item + divider
        const top = 4 + (height * n) // padding-top + list-items
        this.$refs.catalogItems.scrollTo({top, behavior: 'smooth'})
      },
    },
  }
</script>
